<template>
  <artmisads-select
    show-search
    :value="modelValue"
    :style="{ width }"
    :options="options"
    :show-arrow="showArrow"
    :filter-option="false"
    :not-found-content="notFoundContent"
    :placeholder="placeholder"
    :allowClear="allowClear"
    :getPopupContainer="getPopupContainer"
    :disabled="disabled"
    @search="onSearch"
    @change="onChange"
  />
</template>

<script setup>
import { ref, watch } from 'vue'
import { publisherAdminApi } from '~/server/index'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: undefined,
  },
  marketplace: {
    type: String,
    default: 'amazon.com',
  },
  placeholder: {
    type: String,
    default: 'All',
  },
  width: {
    type: String,
    default: '232px',
  },
  allowClear: {
    type: Boolean,
    default: true,
  },
  showArrow: {
    type: Boolean,
    default: false,
  },
  notFoundContent: {
    type: [String, Object],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  getPopupContainer: {
    type: Function,
    default: undefined,
  },
  /** Map option.label / option.value from API item */
  labelKey: {
    type: String,
    default: 'creatorName',
  },
  valueKey: {
    type: String,
    default: 'id',
  },
})

const emit = defineEmits(['update:modelValue', 'change', 'search'])

const options = ref([])

const onSearch = async (keyword) => {
  emit('search', keyword)
  const params = {
    keyword,
    marketplace: props.marketplace || undefined,
  }
  let data = await publisherAdminApi.searchPublisher(params)
  if (data?.length) {
    options.value = data.map((item) => ({
      ...item,
      value: item[props.valueKey],
      label: item[props.labelKey],
    }))
  } else {
    options.value = []
  }
}

const onChange = (value, option) => {
  emit('update:modelValue', value)
  emit('change', value, option)
}

watch(
  () => props.marketplace,
  () => {
    options.value = []
  },
)
</script>
